import React, { useState, useEffect } from "react";
import axios from "axios";
import QRCode from "qrcode.react";
import Cookies from "universal-cookie";
import { API as url1 } from "../../config";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { LOGIN_PATH, MFAVERIFY_PATH } from "../../constants/url";
import {
  ERR_ALERT_TITLE,
  ERR_POSTING,
  SUCC_ALERT_TITLE,
} from "../../constants/alertMessage";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2/dist/sweetalert2";
import {
  Modal,
  Button,
  Grid,
  Dialog,
  TextField,
  Fade,
  Box,
} from "@mui/material";
import { privateApiCall } from "../../api/privateApi";

const Login = () => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(true);
  const [backgroundColor, setBackgroundColor] = useState("#769A0F");
  const [rememberMe, setRememberMe] = useState(false);
  const [initialValues, setInitialValues] = useState({
    email: "",
    password: "",
    errorField: ""
  });
  const [initialValuesMFA, setInitialValuesMFA] = useState({ email: "" });
  const MFASecret = cookies.get("MFASecret");
  const [mfasecret, setMfasecret] = useState(MFASecret);
  const [loginType, setLoginType] = useState(cookies.get("login_type"));
  const [showForgot, setShowForgot] = useState(false);
  const [showMfa, setShowMfa] = useState(false);
  const [resetEmail, setResetEmail] = useState("");

  const [initialValuesResetPassword, setInitialValuesResetPassword] = useState({
    email: "",
  });

  useEffect(() => {
    cookies.remove("jwtToken", { path: "/" });
    cookies.remove("MFASecret", { path: "/" });
    cookies.remove("isEnabled2FA", { path: "/" });
    cookies.remove("login_type", { path: "/" });
    cookies.remove("role", { path: "/" });
    const rememberMeValue = cookies.get("rememberMe");
    if (rememberMeValue) {
      const savedEmail = cookies.get("email");
      const savedPassword = cookies.get("password");
      setInitialValues({ email: savedEmail, password: savedPassword });
      setRememberMe(true);
    }
  }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid Email Address!")
      .required("Email Is Required!"),
    password: Yup.string().required("Password Is Required!"),
  });
  const validationSchemaForgotPass = Yup.object().shape({
    email: Yup.string()
      .required("Email Is Required!")
      .email("Invalid Email Address!"),
  });

  const validationSchemaMFA = Yup.object().shape({
    otp: Yup.string().required("6 Digit Code Is Required"),
  });

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    axios
      .post(`${url1}${LOGIN_PATH}`, {
        email: values.email,
        password: values.password,
      })
      .then((res) => {
        if (res.data.result === "success") {
          cookies.remove("jwtToken", { path: "/" });
          cookies.remove("MFASecret", { path: "/" });
          cookies.remove("isEnabled2FA", { path: "/" });
          cookies.remove("login_type", { path: "/" });
          let role = res.data.role ? res.data.role : {};
          localStorage.setItem("role", JSON.stringify(role))
          let localRole = JSON.parse(localStorage.getItem("role"))
          console.log(localRole.name)

          cookies.set("email", values.email);
          cookies.set("MFASecret", res.data.MFASecret);
          cookies.set(
            "isEnabled2FA",
            res.data.isEnabled2FA ? res.data.isEnabled2FA : false
          );

          const MFASecret = cookies.get("MFASecret");
          const email = cookies.get("email");
          setInitialValuesMFA({ email: email });
          setMfasecret(MFASecret);

          if (rememberMe) {
            cookies.set("rememberMe", true);
            cookies.set("email", values.email);
            cookies.set("password", values.password);
          }

          if (res.data.type === "org") {
            setBackgroundColor("#28A745");
            cookies.set("org_token", res.data.org_token);
            cookies.set("org_id", res.data.org_id);
            cookies.set("org_name", res.data.org_name);
            cookies.set("login_type", "organisation");

            cookies.set("jwtToken", res.data.jwToken);
            if (res.data.isEnabled2FA) {
              setShowLogin(false);
              setShowMfa(true);
            } else {
              navigate("/organisation/dashboard");
            }
            // navigate("/organisation/dashboard");
            //navigate("/mfacheck");
          } else if (res.data.type === "callSupport") {
          } else {
            setBackgroundColor("#769A0F");
            cookies.set("agritech_token", res.data.admin_token);
            cookies.set("agritech_id", res.data.admin_id);
            cookies.set("jwtToken", res.data.jwToken);
            cookies.set("login_type", "admin");
            if (res.data.isEnabled2FA) {
              setShowLogin(false);
              setShowMfa(true);
            } else {
              navigate("/dashboard");
            }
            // navigate("/dashboard");
            //navigate("/mfacheck");
          }
          setLoginType(cookies.get("login_type"));
        } else {
          console.log(res.data.result, "res");
          if (res.data.result === "Invalid Email Id" || res.data.result === "Password is wrong!") {
            setFieldError("errorField", "Invalid Credentials!");
          } else {
            // Handle other errors
          }
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",

          text: `${ERR_POSTING}`,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleSubmitMFA = (values, { setSubmitting, setFieldError }) => {
    let data = {
      email: initialValues.email,
      otp: values.otp,
      MFABase32: mfasecret.base32,
    };
    console.log(data);
    axios
      .post(`${url1}${MFAVERIFY_PATH}`, data)
      .then((res) => {
        if (res.status == 200) {
          if (loginType == "admin") {
            navigate("/dashboard");
          } else if (loginType == "organisation") {
            navigate("/organisation/dashboard");
          }
        } else {
          setFieldError("otp", "MFA verification failed.");
        }
      })
      .catch((err) => {
        setFieldError("otp", "MFA verification failed.");
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: `${ERR_POSTING}`,
        //   confirmButtonText: 'OK'
        // });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleModal = (e) => {
    e.preventDefault();
    setShowLogin(false);
    setShowForgot(true);
  };

  const handleForgotPassSubmit = (
    values,
    { setSubmitting, setFieldError, resetForm }
  ) => {
    let data = {
      resetEmail: values.email,
    };
    const requestUrl = `${url1}/App/forgotPassword`;
    axios
      .post(requestUrl, data)
      .then((res) => {
        resetForm({ values: { email: "" } });

        Swal.fire({
          icon: "success",
          title: `${SUCC_ALERT_TITLE}`,
          text: res?.data?.message,
          confirmButtonText: "OK",
        }).then(() => {
          window.location.href = "/";
        });
      })
      .catch((err) => {
        resetForm({ values: { email: "" } });
        Swal.fire({
          icon: "error",
          title: `${ERR_ALERT_TITLE}`,
          text: err?.response?.data?.message,
          confirmButtonText: "OK",
        }).finally(() => {
          setSubmitting(false);
          resetForm({ values: { email: "" } });
        });
      });
  };
  const handleChange = (event) => {
    setResetEmail(event.target.value);
  };
  return (
    <section
      style={{
        backgroundImage: `url("assets/images/megjack_login.jpeg")`,
        backgroundColor: "#769A0F",
        height: "100vh",
        width: "100vw",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "fixed",
        top: 0,
        left: 0,
        overflow: "hidden",
      }}
    >
    <div className="container-fluid h-100">
    <div className="row justify-content-end h-100 pl-5 pr-3 pt-4">
      <div className="col-lg-6 col-md-8 col-sm-10 pt-4 ">
        {/* Login Form */}
        <div className="card bg-pattern ">
          <div className="card-body p-4">
            <div className="text-center">
              <Link to="/">
                <img src="assets/images/jack_logo.png" alt="" />
              </Link>
            </div>
            {showLogin && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group">
                <label htmlFor="emailaddress">Email Address</label>
                <Field
                  className="form-control"
                  type="email"
                  id="emailaddress"
                  name="email"
                  placeholder="Enter your email"
                /><ErrorMessage
                name="email"
                component="div"
                className="text-danger"
              />

              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <Field
                  className="form-control"
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                /><ErrorMessage
                name="password"
                component="div"
                className="text-danger"
              />
                <ErrorMessage
                  name="errorField"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="form-group d-flex justify-content-between align-items-center">
                <div className="custom-control custom-checkbox checkbox-success">
                  <Field
                    type="checkbox"
                    className="custom-control-input"
                    id="checkbox-signin"
                    name="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => {
                      setRememberMe(e.target.checked);
                      if (!e.target.checked) {
                        cookies.remove("rememberMe");
                        cookies.remove("email");
                        cookies.remove("password");
                      }
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="checkbox-signin"
                  >
                    Remember Me
                  </label>
                </div>


                <label htmlFor="forgot password "><a onClick={handleModal} style={{ textDecoration: 'none', color: 'red' }} href="">Forgot Password?</a></label>
              </div>
              <div className="form-group row align-items-center">
                <div className="col-12">
                  <button
                    className="btn btn-block btn-primary waves-effect waves-light"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Sign In
                  </button>
                  <div className="form-check text-stone-500 text-sm font-normal align-items-center leading-none">
                    <label
                      htmlFor="agreeTerms"
                      className="form-check-label mt-2"
                      style={{ width: "auto" }}
                    >
                      By clicking Sign In you are agreeing to our{" "}
                      <Link  style={{ color: "green" }}
                        className="underline" to="/termsAndCondition"   target="_blank"
                        rel="noopener noreferrer">Terms and Conditions</Link>{" "}
                      and{" "}
                      <Link  style={{ color: "green" }}
                        className="underline" to="/privacypolicy"   target="_blank"
                        rel="noopener noreferrer">Privacy Policy</Link>
                      .
                    </label>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
      {showMfa && (
        <Formik
          initialValues={initialValuesMFA}
          validationSchema={validationSchemaMFA}
          onSubmit={handleSubmitMFA}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form>
              {/* <div className="text-center">
                <h6>Scan this QR Code with Google Authenticator</h6>
                <QRCode value={mfasecret.otpauth_url} />
              </div> */}
              <div className="form-group">
                <h6>
                  Enter the 6 digit code shown in Google Authenticator
                  app
                </h6>
                {/* <label htmlFor="emailaddress">OTP</label> */}
                <Field
                  className="form-control"
                  type="otp"
                  id="otp"
                  name="otp"
                  placeholder="Enter 6 digit code"
                />
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="form-group row align-items-center">
                <div className="col-12">
                  <button
                    className="btn btn-block btn-primary waves-effect waves-light"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Verify MFA Code
                  </button>
                </div>
              </div>
              <div className="form-check text-stone-500 text-sm font-normal align-items-center leading-none">
                <div style={{ visibility: "hidden" }}>
                  <label
                    htmlFor="agreeTerms"
                    className="form-check-label mt-2"
                    style={{ width: "auto" }}
                  >
                    By clicking Sign In you are agreeing to our{" "}
                    <a
                      href="https://www.radtar.com/termsAndConditions.php"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline"
                      style={{ color: "green" }}
                    >
                      {" "}
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.radtar.com/privacyPolicy.php"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "green" }}
                      className="underline"
                    >
                      {" "}
                      Privacy Policy
                    </a>
                    .
                  </label>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
      {showForgot && (
        <Formik
          onSubmit={handleForgotPassSubmit}
          enableReinitialize={true}
          validationSchema={validationSchemaForgotPass}
          initialValues={initialValuesResetPassword}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group">
                <label htmlFor="email address">Email Address</label>
                <Field
                  className="form-control"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="form-group row align-items-center">
                <div className="col-12">
                  <button
                    className="btn btn-block btn-primary waves-effect waves-light"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Send Reset Link
                  </button>
                </div>

              </div>


              <label htmlFor="back to login"><a style={{ textDecoration: 'none', color: 'inherit' }} href="/"> Back to Login</a></label>
              <div className="form-check text-stone-500 text-sm font-normal align-items-center leading-none">
                <div style={{ visibility: "hidden" }}>
                  <label
                    htmlFor="agreeTerms"
                    className="form-check-label mt-2"
                    style={{ width: "auto" }}
                  >
                    By clicking Sign In you are agreeing to our{" "}
                    <a
                      href="https://www.radtar.com/termsAndConditions.php"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline"
                      style={{ color: "green" }}
                    >
                      {" "}
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.radtar.com/privacyPolicy.php"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "green" }}
                      className="underline"
                    >
                      {" "}
                      Privacy Policy
                    </a>
                    .
                  </label>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
            {/* Your Formik form and login components go here */}
          </div>
        </div>
      </div>
    </div>
  </div>
    </section>
  );
};

export default Login;


{/* <div className="container">
<div className="row justify-content-end pt-5">
  <div className="card bg-pattern" style={{ marginRight: "-3rem" }}>
    <div className="card-body mx-auto">
      <div className="text-center  ">
        <Link to="/">
          <span>
            <img src="assets/images/jack_logo.png" alt="" />
          </span>
        </Link>
      </div>
   
    </div>
  </div>
</div>
</div> */}